import React from 'react';
import { t } from 'i18next';
import { FiClipboard, FiEdit3, FiTarget, FiUsers } from 'react-icons/fi';
import { TbCopy } from 'react-icons/tb';
import { CardMetric, CardMetricBody, CardMetricHeader, CardMetricTitle, CardMetricValue, CardMetricWrapper } from '@/components/ui/card-metric';

export default function InfoWidget({ course }) {
  const infoItems = [
    {
      label: t('textsCommon.modules'),
      icon: TbCopy,
      value: course?.['learning-systems'].length ?? 0
    },
    {
      label: t('courses.classes'),
      icon: FiUsers,
      value: course?.['classroom-count'] ?? 0
    },
    {
      label: t('courses.exams'),
      icon: FiTarget,
      value: course?.['exam-count'] ?? 0
    },
    {
      label: t('courses.activities'),
      icon: FiEdit3,
      value: course?.['activity-count'] ?? 0
    },
    {
      label: t('courses.projects'),
      icon: FiClipboard,
      value: course?.['project-count'] ?? 0
    }
  ];

  return (
    <CardMetricWrapper className="mb-0">
      {infoItems.map((item, index) => {
        const Icon = item.icon;

        return (
          <CardMetric
            key={index}
            variant="outline"
          >
            <CardMetricHeader>
              <CardMetricTitle>{item.label}</CardMetricTitle>
            </CardMetricHeader>
            <CardMetricBody>
              <CardMetricValue>
                <Icon /> {item.value}
              </CardMetricValue>
            </CardMetricBody>
          </CardMetric>
        );
      })}
    </CardMetricWrapper>
  );
}
